import { defineMessages } from 'react-intl';

export default defineMessages({
    manageStudents: {
        id: 'app.components.EditClassForm.manageStudents',
        defaultMessage: 'Manage students'
    },
    changeCourse: {
        id: 'app.components.EditClassForm.changeCourse',
        defaultMessage: 'Change course'
    },
    renameGroup: {
        id: 'app.components.EditClassForm.renameGroup',
        defaultMessage: 'Rename group'
    },
    delete: {
        id: 'app.components.EditClassForm.delete',
        defaultMessage: 'Delete group'
    },
    close: {
        id: 'app.components.EditClassForm.close',
        defaultMessage: 'Close'
    },
    deleting: {
        id: 'app.components.EditClassForm.deleting',
        defaultMessage: 'Deleting'
    },
    deleteNonEmptyGroupConfirmation: {
        id: 'app.components.EditClassForm.deleteNonEmptyGroupConfirmation',
        defaultMessage: 'must be empty before it can be deleted.'
    },
    pleaseGoTo: {
        id: 'app.components.EditClassForm.pleaseGoTo',
        defaultMessage: 'Please go to'
    },
    toMoveYourStudents: {
        id: 'app.components.EditClassForm.toMoveYourStudents',
        defaultMessage: 'to move your students.'
    },
    AreYouSureYouWantToDelete: {
        id: 'app.components.EditClassForm.AreYouSureYouWantToDelete',
        defaultMessage: 'Are you sure you want to delete '
    },
    doYouWishTo: {
        id: 'app.components.EditClassForm.doYouWishTo',
        defaultMessage: 'Do you wish to rename the group'
    },
    to: {
        id: 'app.components.EditClassForm.to',
        defaultMessage: 'to'
    },
    questionMark: {
        id: 'app.components.EditClassForm.questionMark',
        defaultMessage: '?'
    },
    yourGroup: {
        id: 'app.components.EditClassForm.yourGroup',
        defaultMessage: 'Your group, '
    },
    hasBeenDeleted: {
        id: 'app.components.EditClassForm.hasBeenDeleted',
        defaultMessage: ', has been deleted.'
    }
});



// WEBPACK FOOTER //
// ./app/components/edit-class-form/delete-group-messages.js